export default __webpack_public_path__ + "static/media/intro.336895b4.png";